import { useRouter } from '@tanstack/react-router'
import { type MouseEvent, useRef } from 'react'

const DRAG_SLOP = 3

function modified(event: MouseEvent) {
  return event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0
}

export function useRowNavigation() {
  const router = useRouter()
  const origin = useRef<{ x: number; y: number } | null>(null)

  return {
    onMouseDown: (event: MouseEvent) => {
      origin.current = { x: event.clientX, y: event.clientY }
    },
    onClick: (event: MouseEvent<HTMLTableRowElement>) => {
      if (modified(event)) return

      if ((event.target as HTMLElement).closest('a, button, input, label, [role="button"]')) return

      const from = origin.current
      const swept =
        from !== null && Math.hypot(event.clientX - from.x, event.clientY - from.y) > DRAG_SLOP

      if (swept || String(window.getSelection() ?? '') !== '') return

      const href = event.currentTarget.querySelector('a')?.getAttribute('href')

      if (href) router.navigate({ to: href })
    },
  }
}
